// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeClaimApi = class EdgeClaimApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param ClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async claimAccumulatorSearch(ClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest, x_program_id) {
        const _url_ = '/edge/claim/v1/Claim/accumulatorSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest' is not null or undefined
        if (ClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest === null || ClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest === undefined) {
            throw new Error('Required parameter ClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest was null or undefined when calling claimAccumulatorSearch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest, "ClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1ClaimAccumulatorSearchAccumulatorSearchResponse");
        }
        return response;
    }
    /**
     *
     * @param ClaimV1ClaimGroupViewSearchGroupViewSearchRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async claimGroupViewSearch(ClaimV1ClaimGroupViewSearchGroupViewSearchRequest, x_program_id) {
        const _url_ = '/edge/claim/v1/Claim/groupViewSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ClaimV1ClaimGroupViewSearchGroupViewSearchRequest' is not null or undefined
        if (ClaimV1ClaimGroupViewSearchGroupViewSearchRequest === null || ClaimV1ClaimGroupViewSearchGroupViewSearchRequest === undefined) {
            throw new Error('Required parameter ClaimV1ClaimGroupViewSearchGroupViewSearchRequest was null or undefined when calling claimGroupViewSearch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ClaimV1ClaimGroupViewSearchGroupViewSearchRequest, "ClaimV1ClaimGroupViewSearchGroupViewSearchRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1ClaimGroupViewSearchGroupViewSearchResponse");
        }
        return response;
    }
    /**
     *
     * @param ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async claimMedicalClaimSearch(ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest, x_program_id) {
        const _url_ = '/edge/claim/v1/Claim/medicalClaimSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest' is not null or undefined
        if (ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest === null || ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest === undefined) {
            throw new Error('Required parameter ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest was null or undefined when calling claimMedicalClaimSearch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest, "ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchResponse");
        }
        return response;
    }
    /**
     *
     * @param id
     * @param x_program_id The program id from the list of allowed program ids
     */
    async claimPaymentBatchById(id, x_program_id) {
        const _url_ = '/edge/claim/v1/Claim/paymentBatchById/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling claimPaymentBatchById.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1ClaimPaymentBatchByIdIdPaymentBatchByIdResponse");
        }
        return response;
    }
    /**
     *
     * @param ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async claimPharmacyClaimSearch(ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest, x_program_id) {
        const _url_ = '/edge/claim/v1/Claim/pharmacyClaimSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest' is not null or undefined
        if (ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest === null || ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest === undefined) {
            throw new Error('Required parameter ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest was null or undefined when calling claimPharmacyClaimSearch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest, "ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchResponse");
        }
        return response;
    }
    /**
     *
     * @param IPlaceOrderRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async claimV1PlaceOrder(IPlaceOrderRequestModel, x_program_id) {
        const _url_ = '/edge/claim/v1/PlaceOrder';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'IPlaceOrderRequestModel' is not null or undefined
        if (IPlaceOrderRequestModel === null || IPlaceOrderRequestModel === undefined) {
            throw new Error('Required parameter IPlaceOrderRequestModel was null or undefined when calling claimV1PlaceOrder.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(IPlaceOrderRequestModel, "IPlaceOrderRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1PlaceOrderDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param ClaimAdjudicationRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async clientAdjudicationThirdParty(ClaimAdjudicationRequest, x_program_id) {
        const _url_ = '/edge/claim/v1/adjudication/thirdParty';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'ClaimAdjudicationRequest' is not null or undefined
        if (ClaimAdjudicationRequest === null || ClaimAdjudicationRequest === undefined) {
            throw new Error('Required parameter ClaimAdjudicationRequest was null or undefined when calling clientAdjudicationThirdParty.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ClaimAdjudicationRequest, "ClaimAdjudicationRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimAdjudicationResponse");
        }
        return response;
    }
    /**
     *
     * @param externalIdType
     * @param externalId
     * @param start
     * @param pageSize
     * @param x_program_id The program id from the list of allowed program ids
     */
    async groupViewSearchClaimsByAccountExternalId(externalIdType, externalId, start, pageSize, x_program_id) {
        const _url_ = '/edge/claim/v1/GroupViewSearch/claimsByAccountExternalId/{externalIdType}/{externalId}/{start}/{pageSize}'
            .replace('{' + 'externalIdType' + '}', encodeURIComponent(String(externalIdType)))
            .replace('{' + 'externalId' + '}', encodeURIComponent(String(externalId)))
            .replace('{' + 'start' + '}', encodeURIComponent(String(start)))
            .replace('{' + 'pageSize' + '}', encodeURIComponent(String(pageSize)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'externalIdType' is not null or undefined
        if (externalIdType === null || externalIdType === undefined) {
            throw new Error('Required parameter externalIdType was null or undefined when calling groupViewSearchClaimsByAccountExternalId.');
        }
        // verify required parameter 'externalId' is not null or undefined
        if (externalId === null || externalId === undefined) {
            throw new Error('Required parameter externalId was null or undefined when calling groupViewSearchClaimsByAccountExternalId.');
        }
        // verify required parameter 'start' is not null or undefined
        if (start === null || start === undefined) {
            throw new Error('Required parameter start was null or undefined when calling groupViewSearchClaimsByAccountExternalId.');
        }
        // verify required parameter 'pageSize' is not null or undefined
        if (pageSize === null || pageSize === undefined) {
            throw new Error('Required parameter pageSize was null or undefined when calling groupViewSearchClaimsByAccountExternalId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1GroupViewSearchClaimsByAccountExternalIdExternalIdTypeExternalIdStartPageSizeClaimsByAccountExternalIdResponse");
        }
        return response;
    }
    /**
     *
     * @param accountId
     * @param start
     * @param pageSize
     * @param x_program_id The program id from the list of allowed program ids
     */
    async groupViewSearchClaimsByAccountId(accountId, start, pageSize, x_program_id) {
        const _url_ = '/edge/claim/v1/GroupViewSearch/claimsByAccountId/{accountId}/{start}/{pageSize}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)))
            .replace('{' + 'start' + '}', encodeURIComponent(String(start)))
            .replace('{' + 'pageSize' + '}', encodeURIComponent(String(pageSize)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling groupViewSearchClaimsByAccountId.');
        }
        // verify required parameter 'start' is not null or undefined
        if (start === null || start === undefined) {
            throw new Error('Required parameter start was null or undefined when calling groupViewSearchClaimsByAccountId.');
        }
        // verify required parameter 'pageSize' is not null or undefined
        if (pageSize === null || pageSize === undefined) {
            throw new Error('Required parameter pageSize was null or undefined when calling groupViewSearchClaimsByAccountId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1GroupViewSearchClaimsByAccountIdAccountIdStartPageSizeClaimsByAccountIdResponse");
        }
        return response;
    }
    /**
     *
     * @param code
     * @param x_program_id The program id from the list of allowed program ids
     */
    async typesCauseTypes(code, x_program_id) {
        const _url_ = '/edge/claim/v1/Types/causeTypes/{code}'
            .replace('{' + 'code' + '}', encodeURIComponent(String(code)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'code' is not null or undefined
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling typesCauseTypes.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesCauseTypesCodeCauseTypesResponse");
        }
        return response;
    }
    /**
     *
     * @param code
     * @param x_program_id The program id from the list of allowed program ids
     */
    async typesClaimStatus(code, x_program_id) {
        const _url_ = '/edge/claim/v1/Types/claimStatus/{code}'
            .replace('{' + 'code' + '}', encodeURIComponent(String(code)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'code' is not null or undefined
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling typesClaimStatus.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesClaimStatusCodeClaimStatusResponse");
        }
        return response;
    }
    /**
     *
     * @param code
     * @param x_program_id The program id from the list of allowed program ids
     */
    async typesPaymentBatchStatus(code, x_program_id) {
        const _url_ = '/edge/claim/v1/Types/paymentBatchStatus/{code}'
            .replace('{' + 'code' + '}', encodeURIComponent(String(code)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'code' is not null or undefined
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling typesPaymentBatchStatus.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesPaymentBatchStatusCodePaymentBatchStatusResponse");
        }
        return response;
    }
    /**
     *
     * @param code
     * @param x_program_id The program id from the list of allowed program ids
     */
    async typesPaymentMethodTypes(code, x_program_id) {
        const _url_ = '/edge/claim/v1/Types/paymentMethodTypes/{code}'
            .replace('{' + 'code' + '}', encodeURIComponent(String(code)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'code' is not null or undefined
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling typesPaymentMethodTypes.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesPaymentMethodTypesCodePaymentMethodTypesResponse");
        }
        return response;
    }
    /**
     *
     * @param code
     * @param x_program_id The program id from the list of allowed program ids
     */
    async typesProcedureTypes(code, x_program_id) {
        const _url_ = '/edge/claim/v1/Types/procedureTypes/{code}'
            .replace('{' + 'code' + '}', encodeURIComponent(String(code)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'code' is not null or undefined
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling typesProcedureTypes.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesProcedureTypesCodeProcedureTypesResponse");
        }
        return response;
    }
    /**
     *
     * @param code
     * @param x_program_id The program id from the list of allowed program ids
     */
    async typesProcessors(code, x_program_id) {
        const _url_ = '/edge/claim/v1/Types/processors/{code}'
            .replace('{' + 'code' + '}', encodeURIComponent(String(code)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'code' is not null or undefined
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling typesProcessors.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesProcessorsCodeProcessorsResponse");
        }
        return response;
    }
    /**
     *
     * @param code
     * @param x_program_id The program id from the list of allowed program ids
     */
    async typesRejectTypes(code, x_program_id) {
        const _url_ = '/edge/claim/v1/Types/rejectTypes/{code}'
            .replace('{' + 'code' + '}', encodeURIComponent(String(code)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'code' is not null or undefined
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling typesRejectTypes.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ClaimV1TypesRejectTypesCodeRejectTypesResponse");
        }
        return response;
    }
};
EdgeClaimApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeClaimApi);
export { EdgeClaimApi };
//# sourceMappingURL=edgeClaimApi.js.map